import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Cabinet } from '../../core/models/cabinet.model';

export const loadCabinets = createAction(
  '[Cabinet] Load Cabinets',
  props<{ cabinets: Cabinet[] }>()
);

export const addCabinet = createAction(
  '[Cabinet] Add Cabinet',
  props<{ cabinet: Cabinet }>()
);

export const upsertCabinet = createAction(
  '[Cabinet] Upsert Cabinet',
  props<{ cabinet: Cabinet }>()
);

export const addCabinets = createAction(
  '[Cabinet] Add Cabinets',
  props<{ cabinets: Cabinet[] }>()
);

export const upsertCabinets = createAction(
  '[Cabinet] Upsert Cabinets',
  props<{ cabinets: Cabinet[] }>()
);

export const updateCabinet = createAction(
  '[Cabinet] Update Cabinet',
  props<{ cabinet: Update<Cabinet> }>()
);

export const updateCabinets = createAction(
  '[Cabinet] Update Cabinets',
  props<{ cabinets: Update<Cabinet>[] }>()
);

export const deleteCabinet = createAction(
  '[Cabinet] Delete Cabinet',
  props<{ id: string }>()
);

export const deleteCabinets = createAction(
  '[Cabinet] Delete Cabinets',
  props<{ ids: string[] }>()
);

export const clearCabinets = createAction(
  '[Cabinet] Clear Cabinets'
);
